export default __webpack_public_path__ + "static/media/services_dev_0365.c590c9b1.svg";